export const SwallowedMap = Object.freeze(new Map());

export const SwallowedMetricGroup = Object.freeze({
  count: 0,
  cost: 0,
  groups: 0,
  roles: 0,
  managers: 0,
  activities: 0,
  hours: 0,
  people: 0,
  fte: 0,
  budget: 0,
  span: 0,
  tags: {
    ACTIVITY: {},
    GROUP: {},
    ROLE: {},
  },
});

export const SwallowedEntityMetrics = Object.freeze({
  managed: {
    total: SwallowedMetricGroup,
    visible: SwallowedMetricGroup,
  },
  self: {
    total: SwallowedMetricGroup,
    visible: SwallowedMetricGroup,
  },
  span: {
    total: SwallowedMetricGroup,
    visible: SwallowedMetricGroup,
  },
});
